import Callback from '@/services/Callback'
import To from 'await-to-js'
import qs from 'qs'
import RecordOperation from '@/services/Record'
import { wizStandardInstance } from '@/services/instance'

export default class StdClassService {
  static async detail(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(wizStandardInstance.get(`/api/std/StdClass/?id=${payload.id}`))
    return Callback(err, res)
  }
  static async list(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClass?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async create(payload) {
    RecordOperation({ type: 'create' })
    const [err, res] = await To(wizStandardInstance.post('/api/std/StdClass', payload))
    return Callback(err, res)
  }
  static async update(payload) {
    RecordOperation({ type: 'update' })
    const [err, res] = await To(wizStandardInstance.patch('/api/std/StdClass', payload))
    return Callback(err, res)
  }
  static async remove(payload) {
    RecordOperation({ type: 'delete' })
    const [err, res] = await To(
      wizStandardInstance('/api/std/StdClass', {
        method: 'delete',
        data: payload,
      })
    )
    return Callback(err, res)
  }
  static async upload(payload) {
    RecordOperation({ type: 'import' })
    const [err, res] = await To(wizStandardInstance.post('/api/std/StdClass/import', payload))
    return Callback(err, res)
  }
  static async exportFile(payload) {
    RecordOperation({ type: 'export' })
    const [err, res] = await To(wizStandardInstance.post('/api/std/StdClass/export', payload))
    return Callback(err, res)
  }
  static async downloadTemplate(payload) {
    RecordOperation({ type: 'export' })
    const [err, res] = await To(wizStandardInstance.post('/api/std/StdClass/download', payload))
    return Callback(err, res)
  }
  static async publish(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClass/publish?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 获取设置关系-关系类型
  static async getRelationType() {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get('/api/std/StdClassRelation/get_relation_type')
    )
    return Callback(err, res)
  }
  // 设置关系-更新实体
  static async updateRelation(payload) {
    RecordOperation({ type: 'update' })
    const [err, res] = await To(wizStandardInstance.patch('/api/std/StdClassRelation', payload))
    return Callback(err, res)
  }
  // 设置关系-保存实体
  static async addRelation(payload) {
    RecordOperation({ type: 'create' })
    const [err, res] = await To(wizStandardInstance.post('/api/std/StdClassRelation', payload))
    return Callback(err, res)
  }
  // 设置关系-通过id回显查询
  static async getRelation(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(wizStandardInstance.get(`/api/std/StdClassRelation/${payload.id}`))
    return Callback(err, res)
  }
  // 删除关系
  static async removeRelation(payload) {
    RecordOperation({ type: 'delete' })
    const [err, res] = await To(wizStandardInstance.delete('/api/std/StdClassRelation', payload))
    return Callback(err, res)
  }
}
